import config from 'config';
import { Me } from 'types/iam';
import fetchWithToken from './provider/fetch';

const scimMeEndPoint = (): string => `${config.EXT_ADMIN_SERVICE_URL}`;

export const daoMeGet = (childAccountKey?: string, managedAccountKey?: string): Promise<Me> => {
  const queryValues: string[] = [];

  let reqUrl = `${scimMeEndPoint()}/me`;

  if (managedAccountKey) {
    queryValues.push(`managedAccountKey=${managedAccountKey}`);
  }
  if (childAccountKey) {
    queryValues.push(`childAccountKey=${childAccountKey}`);
  }

  reqUrl = `${reqUrl}${queryValues.length ? `?${queryValues.join('&')}` : ''}`;

  return fetchWithToken({
    reqUrl,
    body: null,
    method: 'GET',
    isTenant: false,
  });
};

export default {
  daoMeGet,
};
